import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetComponents({ commit }, data) {
    commit(types.RESET_COMPONENTS, data)
  },
  resetComponent({ commit }, data) {
    commit(types.RESET_COMPONENT, data)
  },
  setComponentData({ commit }, data) {
    commit(types.SET_COMPONENT_DATA, data)
  },
  resetMedia({ commit }, data) {
    commit(types.RESET_MEDIA, data)
  },
  resetMediaItem({ commit }, data) {
    commit(types.RESET_MEDIA_ITEM, data)
  },
  setMediaData({ commit }, data) {
    commit(types.SET_MEDIA_DATA, data)
  },
  async getDashboardName({ commit }, id) {
    const r = await http.get(`v2/components/dashboardname/${id}`)
    commit(types.SET_DASHBOARDNAME, r.data.data)
    return r.data.data
  },
  async getComponents({ commit }, data) {
    const r = await http.get(`v2/components`, {
      params: data,
    })
    commit(types.SET_COMPONENTS, r.data.data)
    return r.data.data
  },
  async editComponent({ commit }, data) {
    commit(types.SET_COMPONENT, data)
  },
  async getComponent({ commit }, id) {
    const r = await http.get(`v2/components/${id}`)
    commit(types.SET_COMPONENT, r.data.data)
    return r.data.data
  },
  async saveComponent({ commit }, data) {
    let r = null
    r = await http.post('v2/components', data)
    data = {
      name: 'id',
      value: r.data.data.id,
    }
    commit(types.SET_COMPONENT_DATA, data)
    return r.data.data
  },
  async removeComponent({ commit }, id) {
    const r = await http.delete(`v2/components/${id}`)
    return r.data.data
  },

  async getMedia({ commit }, data) {
    const r = await http.get(`v2/components/media`, {
      params: data,
    })
    commit(types.SET_MEDIA, r.data.data)
    return r.data.data
  },
  async getMediaItem({ commit }, id) {
    const r = await http.get(`v2/components/mediaItem/${id}`)
    commit(types.SET_MEDIA_ITEM, r.data.data)
    return r.data.data
  },
  async saveMedia({ commit }, data) {
    let r = null
    r = await http.post('v2/components/mediaItem', data)
    return r.data.data
  },
  async removeMedia({ commit }, id) {
    const r = await http.delete(`v2/components/mediaItem/${id}`)
    return r.data.data
  },
  async getMemberStatus({ commit }, data) {
    const r = await http.get(`v2/components/memberStatus`, {
      params: data,
    })
    commit(types.SET_MEMBER_STATUS, r.data.data)
    return r.data.data
  },
}
